/**
 * Design tokens — colour, font, radius and shadow.
 *
 * The values live in tokens.json, the single source of truth. Edit them there.
 * It is JSON because two very different consumers read it:
 *   - tailwind.config.js (plain Node) requires it, so every `bg-primary-700`,
 *     `text-danger-600`, `rounded-card`, `shadow-modal` class and every
 *     `--color-*` / `--radius-*` / `--shadow-*` CSS variable comes from it.
 *   - App code imports this module for raw values where a class won't do
 *     (SweetAlert2 options, ApexCharts series colours, driver.js):
 *       import { colors } from "theme/tokens";
 *       colors.primary[700] // "#09579b"
 *
 * What each token is for: docs/THEME.md.
 *
 * Scales:
 *   primary  Brand. 700 is the brand colour.
 *   danger   Tailwind red   — destructive actions, errors.       DEFAULT = 600
 *   success  Tailwind green — completed, delivered, active.      DEFAULT = 600
 *   warning  Tailwind amber — needs attention, not an error.     DEFAULT = 500
 *   neutral  Tailwind neutral — text, borders, surfaces. The only grey scale.
 *   link     Text links.    DEFAULT = primary-700, hover = primary-800
 * The status scales use Tailwind's own values, so swapping `red-600` for
 * `danger-600` changes nothing visually.
 *
 * borderRadius is named by role (control 6px, card 8px, modal 12px — the same
 * values as rounded-md / -lg / -xl). boxShadow has three elevations (card,
 * dropdown, modal — the same values as shadow-sm / -lg / -xl).
 */
import tokens from "./tokens.json";

export const colors = tokens.colors;
export const fontFamily = tokens.fontFamily;
export const borderRadius = tokens.borderRadius;
export const boxShadow = tokens.boxShadow;

export default tokens;
